import React, { useState, useEffect } from "react";
import LibrarySubjectCM from "./LibrarySubjectCM";
import { Link, NavLink } from "react-router-dom";
import { handleIcons } from "./iconsData";
export default function LibrarySubjectProps({ data, index }) {
  const [dummyArr, setDummyArray] = useState([]);
  useEffect(() => {
    const storedArray = JSON.parse(localStorage.getItem("LibraryNav")) || [];
    const updatedArray = [...storedArray];
    updatedArray[index] = data;
    setDummyArray(updatedArray);
    localStorage.setItem("LibraryNav", JSON.stringify(updatedArray));
  }, [data, index]);
  const handleIcon = (SubName) => {
    let res = handleIcons(SubName);
    return res;
  };

  console.log("data", data);

  return (
    <div className="d-flex flex-wrap gap-3">
      {data?.length > 0 &&
        data.map((obj, index) => {
          const hasBooks = obj.bookInfo.length > 0;
          const subjectCard = (
            <LibrarySubjectCM
              subname={obj?.subjectId?.name}
              sublogo={handleIcon(obj?.subjectId?.name)}
              bookList={`${obj.bookInfo.length} ${
                obj.bookInfo.length === 1 ? "Book" : "Books"
              }`}
            />
          );

          return hasBooks ? (
            <NavLink
              key={index}
              className="link"
              state={{
                indexSub: index,
                sectionId: obj.sectionId,
                standardId: obj.standardId,
                subjectId: obj.subjectId._id,
              }}
              to="/library/subjectDetails"
            >
              {subjectCard}
            </NavLink>
          ) : (
            <div key={index} className="link-disabled">
              {subjectCard}
            </div>
          );
        })}
    </div>
  );
}
